const BACKOFFICE_BASE_API_V1 =
  process.env.REACT_APP_BACKOFFICE_BASE_API_V1 ||
  "https://backoffice.kazhavda.mk/api/v1";

export default BACKOFFICE_BASE_API_V1;

export const BACKOFFICE_ORIGIN = new URL(BACKOFFICE_BASE_API_V1).origin;
